import axios from 'axios'

const RequestService = {
  async get (params = {}) {
    return axios.get('rm/purchase-order/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('rm/reports/purchase-order/request-histories', { params })
  },

  async show (id) {
    return axios.get(`rm/purchase-order/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('rm/purchase-order/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`rm/purchase-order/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rm/purchase-order/requests/${data.id}`, { data })
  }
}

export default RequestService
